import { render, staticRenderFns } from "./InvoiceAttachmentFileTable.vue?vue&type=template&id=147f9b86&scoped=true"
import script from "./InvoiceAttachmentFileTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoiceAttachmentFileTable.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvoiceAttachmentFileTable.vue?vue&type=style&index=0&id=147f9b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147f9b86",
  null
  
)

export default component.exports